import { render, staticRenderFns } from "./personList.vue?vue&type=template&id=5d9970ba&scoped=true&"
import script from "./personList.vue?vue&type=script&lang=js&"
export * from "./personList.vue?vue&type=script&lang=js&"
import style0 from "./personList.vue?vue&type=style&index=0&id=5d9970ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9970ba",
  null
  
)

component.options.__file = "personList.vue"
export default component.exports